// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DcM2","left":"styles_left__13i0g","desktopActions":"styles_desktopActions__1q69N","title":"styles_title__3B_vN"};